import React from 'react'
import { useTranslation } from 'react-i18next'
import TableRowStatus from 'routes/Transits/Table/TableRowStatus'
import { TransitOperation } from 'features/declaration/transit-operation/models/types'

interface NavigationBarInfoProps {
  transitOperation?: TransitOperation
  declarationKind?: 'transit' | 'ens'
}

function NavigationBarInfo({ transitOperation, declarationKind } : Readonly<NavigationBarInfoProps>) {
  const { t } = useTranslation()
  const {
    id: transitOperationId, mrn, lrn, status,
  } = transitOperation ?? { }

  const typeLabel = declarationKind === 'ens' ? 'ENS' : t('transit.title')

  return (
    <div className="d-flex align-items-center gap-4 py-3 h-100">
      <h1 className="declaration__title">
        {`${transitOperation ? t('common.edit') : t('common.new')} ${typeLabel}`}
      </h1>
      <span className="declaration__title-divider" aria-hidden="true" />
      <div className="d-flex align-items-center gap-3">
        {transitOperationId && (
          <span className="editor-tag editor-tag--dark">{`${t('transit.id')}: ${transitOperationId}`}</span>
        )}
        {mrn && (
          <span className="editor-tag editor-tag--dark">{`${t('common.mrn')}: ${mrn}`}</span>
        )}
        {!mrn && lrn && (
          <span className="editor-tag editor-tag--dark">{`${t('common.lrn')}: ${lrn}`}</span>
        )}
        <TableRowStatus value={status ?? 'DRAFT'} asBadge />
      </div>
    </div>
  )
}

NavigationBarInfo.defaultProps = {
  transitOperation: undefined,
  declarationKind: 'transit',
}

export default NavigationBarInfo
